<template>
    <div class="wrapper-tab-prize">
        <div class="top-title text-center" v-if="$device.isMobileOrTablet">
            <img src="/assets/img/event/worldcup/tabs/img-title-mb.png" alt="prize">
        </div>
        <div class="tab-prize">
            <div v-for="(item, index) in dataListPizes" :key="item && item.id" :class="['tab-prize__item', $device.isMobileOrTablet && item.id == 13 ? 'd-none' : '']">
                <div class="effect-hover">
                    <img v-if="item.id == 13" class="tab-prize__thumb"
                    :src="item.image" alt="prize">
                    <img v-else class="tab-prize__thumb"
                    :src="`/assets/img/event/worldcup/tabs/bg-giai-thuong-${(index + 1) % 2 == 0 ? '2':'1'}.png`" alt="prize">
                </div>
                <div class="icon-box">
                    <img class="img"
                    :src="winPrizesImage(item.prizeKey)" alt="prize">
                </div>
                <div v-if="item.remains || item.quantity" class="content">
                    <div class="title">{{ handleTitlePizes(item.prizeKey )}}</div>
                    <div class="sub">
                        <div v-if="item.prizeKey !== 'lucky' && item.quantity !== -1">
                            SL: <span>{{item.remains}}</span>/<span>{{item.quantity}}</span>
                        </div>
                        <div v-if="item.type === 'match_win'">+3 ĐIỂM</div>
                        <div v-if="item.type === 'match_draw'">+2 ĐIỂM</div>
                        <div v-if="item.type === 'match_lose'">+1 ĐIỂM</div>
                        <div v-if="item.quantity == -1 && item.prizeKey === 'sieuhoantra'">KHÔNG GIỚI HẠN</div>
                        <div v-if="item.prizeKey === 'lucky' && item.quantity == -1">CHÚC MAY MẮN</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import { mapState } from 'vuex';
import { eventWorldcupInfo } from '@/resources/worldcup/worldcup';

export default {
    data() {
        return {
            eventWorldcupInfo,
            dataListPizes: null,
            dataImage: {
                id: 13,
                image: 'assets/img/event/worldcup/tabs/prize-special.png'
            }
        };
    },
    mounted() {
        this.getRewards();
    },
    watch: {
        dataRewards(value) {
            const data = [...value.slice(0, 6), this.dataImage, ...value.slice(6, value.length)];
            this.dataListPizes = data;
        }
    },
    computed: {
        currentUser() {
            return this.$store.state.user;
        },
        ...mapState('event/worldcup-wheel', {
            dataRewards: state => state.wheelEvent.dataRewards
        })
    },
    methods: {
        winPrizesImage(data) {
            switch (data) {
                case '10k':
                case '100k':
                case '1trieu':
                case '2trieu':
                case '300k':
                case '50k':
                case '500k':
                    return '/assets/img/event/worldcup/section-wheel/dolar.png';
                case 'goalthang':
                    return '/assets/img/event/worldcup/section-wheel/point-3.png';
                case 'hoa':
                    return '/assets/img/event/worldcup/section-wheel/point-1.png';
                case 'lucky':
                    return '/assets/img/event/worldcup/section-wheel/point-lucky.png';
                case 'sieuhoantra':
                    return '/assets/img/event/worldcup/section-wheel/point-km.png';
                default:
                    return '/assets/img/event/worldcup/section-wheel/point-2.png';
            }
        },
        handleTitlePizes(data) {
            switch (data) {
                case '10k':
                    return '10k';
                case '100k':
                    return '100k';
                case '1trieu':
                    return '1 triệu';
                case '2trieu':
                    return '2 triệu';
                case '300k':
                    return '300k';
                case '50k':
                    return '50k';
                case '500k':
                    return '500k';
                case 'goalthang':
                    return 'THẮNG';
                case 'hoa':
                    return 'HÒA';
                case 'lucky':
                    return 'LUCKY';
                case 'sieuhoantra':
                    return 'HOÀN TRẢ 3%';
                default:
                    return 'THUA';
            }
        },
        async getRewards() {
            try {
                await this.$store.dispatch('event/worldcup-wheel/getRewards');
            } catch (e) {
                console.log(e);
            }
        }
    }
};
</script>
